import { memo } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import {
  AiOutlineFacebook,
  AiOutlineInstagram,
  AiOutlineLinkedin,
  AiOutlineYoutube,
} from 'react-icons/ai';

const useStyles = makeStyles(theme => ({
  '& .social': {
    margin: '15px auto',
    cursor: 'pointer',
  },
  svg: {
    transition: '0.4s',
    color: 'rgba(65, 57, 60, 0.7)',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  wrapper: {
    cursor: 'pointer',
    display: 'inline-block',
  },
}));

const SocialLinks = memo(() => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className="social">
      <div className={classes.wrapper}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={t('facebookLink')}
          alt="Facebook"
        >
          <AiOutlineFacebook size={24} className={classes.svg} />
        </a>
      </div>
      <div className={classes.wrapper}>
        <a
          rel="noopener noreferrer"
          alt="Instagram"
          href={t('instagramLink')}
          target="_blank"
        >
          <AiOutlineInstagram size={24} className={classes.svg} />
        </a>
      </div>
      <div className={classes.wrapper}>
        <a
          rel="noopener noreferrer"
          alt="LinkedIn"
          href={t('linkedinLink')}
          target="_blank"
        >
          <AiOutlineLinkedin size={24} className={classes.svg} />
        </a>
      </div>
      <div className={classes.wrapper}>
        <a
          rel="noopener noreferrer"
          alt="Youtube"
          href="https://www.youtube.com/channel/UCI-hGSQN2i4l4Q-cYAcK-Yg"
          target="_blank"
        >
          <AiOutlineYoutube size={24} className={classes.svg} />
        </a>
      </div>
    </div>
  );
});

SocialLinks.displayName = 'SocialLinks';

export default SocialLinks;
